import classNames from 'classnames'
import type { Props } from './product-card-gallery'
import EnergyLabel, { TextAlignment } from '../energy-label/energy-label'
type EnergyProps = {
  id: Props['product']['id']
  nameSlug: Props['product']['nameSlug']
  manufacturerName: Props['product']['manufacturerName']
  displayName: Props['product']['displayName']
  displaySpecifications: Props['product']['displaySpecifications']
  energyClass: Props['product']['energyClass']
  energyDocumentId: Props['product']['energyDocumentId']
  energyLabelImageId: Props['product']['energyLabelImageId']
  textAlignment: TextAlignment
  isMinSmallMobile: boolean
  className?: string
}
export default function Energy({
  id,
  nameSlug,
  manufacturerName,
  displayName,
  displaySpecifications,
  energyClass,
  energyDocumentId,
  energyLabelImageId,
  textAlignment,
  isMinSmallMobile,
  className,
}: EnergyProps) {
  return (
    <EnergyLabel
      energyClass={energyClass}
      energyDocumentId={energyDocumentId}
      energyLabelImageId={energyLabelImageId}
      productId={id}
      nameSlug={nameSlug}
      productTitle={`${manufacturerName} ${displayName} ${displaySpecifications}`}
      width={45}
      textAlignment={textAlignment}
      className={classNames('d-block', className, {
        'u-mb-16': !isMinSmallMobile,
        'u-mb-12': isMinSmallMobile,
      })}
    />
  )
}
